<template>
    <modal
        :title="translations.title || 'Delete custom referral url'"
        size="small"
        :cancel_btn_title="translations.cancel || 'Cancel'"
        name="partner_delete_custom_link"
    >
        <template #toggle>
            <options-item title="Delete"/>
        </template>
        <template #body>
            <fieldset>
                <div class="-space-y-px bg-white rounded-md text-left">
                    {{ translations.deleteQuestion || 'Do you really want to delete this custom referral url ?' }}
                </div>
                <div class="-space-y-px bg-white rounded-md text-left">
                    {{ url }}
                </div>
            </fieldset>
            <div class="space-y-6" v-if="error">
                <span class="text-red-600 text-sm">{{ error }}</span>
            </div>
        </template>
        <template #footer>
            <btn v-on:click="deleteCustomLink" :loading="loading">
                {{ translations.deleteConfirmation || 'Yes, Delete' }}
            </btn>
        </template>
    </modal>
</template>
<script>
import OptionsItem from "../../elements/options/OptionsItem";
export default {
    components: {OptionsItem},
    props: ['id', 'url', 'delete_url', 'translations'],
    data() {
        return {
            error: false,
            loading: false,
        }
    },
    methods: {
        deleteCustomLink() {

            if (this.loading) {
                return;
            }

            this.error = false;
            this.loading = true;

            axios
                .post(this.delete_url, {link_id: this.id})
                .then(response => {
                    const status = parseInt(response.data.status ?? 0);
                    if (status === 1) {
                        this.emitter.emit('modal-off', 'partner_delete_custom_link');
                        window.location.reload();
                    } else {
                        this.error = 'Failed to delete custom link';
                    }
                })
                .catch(error => {
                    let errors = error.response.data.error || false;
                    this.error = Array.isArray(errors) ? errors[0] : errors;
                }).finally(() => this.loading = false);
        }
    }
}
</script>
